var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronsLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17l-5-5 5-5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17l-5-5 5-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsLeftIcon);
export default __webpack_public_path__ + "static/media/ChevronsLeftIcon.b71d6e901952bc0df60e64c6fc0448f0.svg";
export { ForwardRef as ReactComponent };